import { Reveal } from "../Reveal";

const PILLARS = [
  {
    n: "01",
    t: "A culture of Made in Italy",
    d: "Few regions in the world value Italian craftsmanship as deeply as the Gulf. The cultural foundation for AIS is already here.",
  },
  {
    n: "02",
    t: "A market for our silhouettes",
    d: "Climate, dress codes and lifestyles of the Gulf align precisely with the AIS catalogue — slip-on shapes, refined leathers, resort-to-city ease.",
  },
  {
    n: "03",
    t: "Our 100% focus",
    d: "The Gulf is not one market among many. It is the market. Calendar, capsules and brand development are entirely dedicated to it.",
  },
  {
    n: "04",
    t: "A partnership of equals",
    d: "Brand and distributor grow side by side. The collaboration shapes the assortment, the storytelling and the regional ascent — together.",
  },
];

export default function Slide07WhyGCC() {
  return (
    <section
      className="slide bg-[var(--ais-espresso)] text-[var(--ais-cream)] grain"
      data-testid="slide-07"
    >
      <div className="min-h-screen flex items-center px-6 md:px-16 lg:px-24 py-24">
        <div className="w-full max-w-6xl mx-auto">
          <Reveal>
            <span className="font-sans text-[0.7rem] uppercase tracking-luxe text-[var(--ais-gold)]">
              07 — Why the Gulf
            </span>
          </Reveal>
          <Reveal delay={1}>
            <div className="h-px w-16 my-8 bg-[var(--ais-gold)]/70" />
          </Reveal>
          <Reveal delay={2}>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.75rem] text-[var(--ais-cream)] leading-[1.05] tracking-[-0.01em] font-light max-w-4xl">
              A brand built around a single market —
              <br />
              <em className="italic">because</em> it is the right one.
            </h2>
          </Reveal>

          <div className="mt-12 md:mt-14 grid grid-cols-1 md:grid-cols-4 gap-0 border-t border-[var(--ais-gold)]/40">
            {PILLARS.map((s, i) => (
              <Reveal key={s.n} delay={3 + i}>
                <div
                  className={`py-8 md:py-10 px-2 md:px-6 border-b md:border-b-0 border-[var(--ais-gold)]/40 ${
                    i !== 0 ? "md:border-l" : ""
                  }`}
                >
                  <div className="font-serif italic text-4xl md:text-5xl text-[var(--ais-gold)] font-light leading-none">
                    {s.n}
                  </div>
                  <div className="mt-5 font-serif text-xl md:text-[1.45rem] text-[var(--ais-cream)] font-light leading-tight">
                    {s.t}
                  </div>
                  <p className="mt-3 font-sans text-sm text-[var(--ais-cream)] opacity-80 leading-[1.75] font-light">
                    {s.d}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
